import styled from 'styled-components'
import { Modal, Image, Popup } from 'semantic-ui-react'

export const Logo = styled(Image)`
  width: 200px;
  height: auto;
  margin: 2em 0;
`

export const StyledModal = styled(Modal)`
  &&& {
    display: flex;
    flex-flow: column nowrap;
    justify-content: ${props => props.justify || 'flex-start'};
    align-items: ${props => props.align || 'center'};
  }
`

export const StyledModalContent = styled(Modal.Content)`
  padding: 10px;
`

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 500px;
`

export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border: none;
  color: ${props => props.theme.colors.sapphireBlue};

  :hover {
    cursor: pointer;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: ${props => props.direction || 'row'};
  justify-content: ${props => props.justify || 'center'};
  align-items: ${props => props.align || 'center'};
  width: 100%;
  max-width: ${props => props.maxWidth || 'none'};
  padding: ${props => props.padding || '0.5rem'};
  align-self: center;
`

export const ErrorMsg = styled.span`
  color: ${props => props.theme.colors.carnelian};
  align-self: center;
  margin-bottom: 0;
`

export const FieldWrapper = styled.div`
  width: 100%;
  max-width: 300px;
  margin-top: 0.5rem;
`

export const StyledText = styled.span`
  font-size: 1rem;
`

export const StyledTextBold = styled.span`
  font-size: 1rem;
  font-weight: bold;
`

export const StyledTextBlue = styled.span`
  font-size: 1rem;
  color: ${props => props.theme.colors.metallicSeaweed};
  font-weight: bold;
  cursor: pointer;
`

export const StyledImage = styled.img`
  height: 24px;
  width: 24px;
  cursor: pointer;
`

export const ThemedPopup = styled(Popup)`
  &&& {
    background: ${props => props.theme.colors.turquoiseGreen};
    &.ui.bottom.popup:before {
      background: ${props => props.theme.colors.turquoiseGreen};
    }
  }
`
